import * as React from 'react';
import { useState } from 'react';

/** Material UI Packages. */
import { Box, Typography, Tooltip, IconButton } from '@mui/material';

/** Material UI Icons. */
import HistoryIcon from '@mui/icons-material/History';

export default function TooltipTypography({ label, tooltipLabel, placement }) {
    return (
        <Box>
            <Typography sx={{ display: 'inline', fontSize: '12px', color: '#003a52', fontWeight: 500 }}>
                {label}
            </Typography>
            <Tooltip title={<span dangerouslySetInnerHTML={{ __html: tooltipLabel }} />} placement={placement} arrow>
                <IconButton
                    sx={{
                        color: 'white',
                        bgcolor: 'primary.dark',
                        borderRadius: '15px',
                        p: '3px',
                        ml: '5px',
                        ':hover': { bgcolor: 'rgb(0,100,126)', color: 'white' },
                    }}
                >
                    <HistoryIcon sx={{ fontSize: '17px' }} />
                </IconButton>
            </Tooltip>
        </Box>
    );
}
